/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ImportAenderung } from './ImportAenderung';
import {
    ImportAenderungFromJSON,
    ImportAenderungFromJSONTyped,
    ImportAenderungToJSON,
} from './ImportAenderung';
import type { RsrImport } from './RsrImport';
import {
    RsrImportFromJSON,
    RsrImportFromJSONTyped,
    RsrImportToJSON,
} from './RsrImport';

/**
 * 
 * @export
 * @interface RsrImportAntwort
 */
export interface RsrImportAntwort {
    /**
     * 
     * @type {Array<ImportAenderung>}
     * @memberof RsrImportAntwort
     */
    importAenderungen: Array<ImportAenderung>;
    /**
     * 
     * @type {RsrImport}
     * @memberof RsrImportAntwort
     */
    rsrImport: RsrImport;
}

/**
 * Check if a given object implements the RsrImportAntwort interface.
 */
export function instanceOfRsrImportAntwort(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "importAenderungen" in value;
    isInstance = isInstance && "rsrImport" in value;

    return isInstance;
}

export function RsrImportAntwortFromJSON(json: any): RsrImportAntwort {
    return RsrImportAntwortFromJSONTyped(json, false);
}

export function RsrImportAntwortFromJSONTyped(json: any, ignoreDiscriminator: boolean): RsrImportAntwort {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'importAenderungen': ((json['importAenderungen'] as Array<any>).map(ImportAenderungFromJSON)),
        'rsrImport': RsrImportFromJSON(json['rsrImport']),
    };
}

export function RsrImportAntwortToJSON(value?: RsrImportAntwort | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'importAenderungen': ((value.importAenderungen as Array<any>).map(ImportAenderungToJSON)),
        'rsrImport': RsrImportToJSON(value.rsrImport),
    };
}

